// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__n7nTM","checkmark":"Checkbox_checkmark__ILuwk"};